import { Document, Page } from 'react-pdf';
import Loading from '../../../shared/Loading/Loading';

const FileView = (props) => {
  return (
    <aside className="w-full overflow-hidden rounded-lg bg-white p-3 shadow-sm sm:p-5 md:p-6">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-lg font-bold text-gray-800 sm:text-xl md:text-2xl">
          Términos y Condiciones
        </h2>
        <button
          type="button"
          onClick={props.handleCloseViewer}
          className="w-full rounded-md border border-personalized bg-personalized px-4 py-2 text-sm font-medium text-white transition hover:bg-white hover:text-personalized sm:w-auto"
        >
          Volver
        </button>
      </div>
      <div className="max-h-[58vh] overflow-y-auto overflow-x-hidden rounded-lg border border-gray-300 bg-gray-200 p-3 sm:p-4">
        <Document
          file={props.fileUrl}
          onLoadSuccess={props.onDocumentLoadSuccess}
          loading={(
            <div className="flex justify-center py-6">
              <Loading size="6" colorBase="gray-100" colorAccent="personalized" double />
            </div>
          )}
          error={<p className="text-sm text-red-500">No fue posible cargar el PDF.</p>}
        >
          <div className="flex flex-col items-center">
            {Array.from({ length: props.numPages || 0 }, (_, index) => (
              <div
                key={`page_wrapper_${index + 1}`}
                className="mb-2 w-fit rounded-md border border-gray-200 bg-white p-2 shadow-lg last:mb-0"
              >
                <Page
                  pageNumber={index + 1}
                  width={props.pageWidth}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </div>
            ))}
          </div>
        </Document>
      </div>
    </aside>
  );
};

export default FileView;
